module.exports = __webpack_public_path__ + "javascripts/components/Podcast/SubscriptionOption/google_podcasts-5f9f696b362a76adb52f573792f01810.svg";